<template>
  <div class="mb-4">
    <div>
      <h3>{{ "request_done" | setText("Заявка успешно сформирована") }}</h3>
      <h4>
        {{ "order_number" | setText("Номер заказа") }}: {{ data.exchange_id }}
      </h4>
      <a
        class="btn btn-info btn-icon mw"
        :href="currentRequest.response.link_download"
        target="_blank"
      >
        {{ "policy_download" | setText("Смотреть файл") }}
      </a>
    </div>
  </div>
</template>
<script>
import {
  logger,
  errorNotify,
  toFormData,
  dateConvert,
  addMonth,
} from "@/plugins/functions";

export default {
  methods: {
    async sendRequest() {
      this.$loading(true);
      const url = `${this.currentRequest.service.api_endpoint_url}cancel`;
      const method = "post";
      const headers = {
        Authorization:
          "Basic " +
          btoa(
            this.currentRequest.service.api_login +
              ":" +
              this.currentRequest.service.api_password
          ),
      };

      //DATA
      let data = {};

      //REQUEST
      return this.$http({
        method: method,
        data: data,
        url: url,
        headers: headers,
      })
        .then((response) => {
          const responseData = response.data;
          if (responseData) {
            switch (responseData.result) {
              case 0:
                this.$emit("input", {
                  service_request: {
                    state: "sent",
                    service: "apex",
                    exchange_id: responseData.contract_id,
                    response: JSON.stringify(responseData),
                    body: JSON.stringify(data),
                  },
                });
                break;

              default:
                break;
            }

            if (responseData.result_message) {
              this.$notify({
                title: "APEX",
                message: responseData.result_message,
                icon: "ti-info",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
            }
          }

          return responseData;
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  props: ["value", "data", "currentRequest"],
};
</script>
<style>
</style>
 